import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a1f278df92169d342ff3d34089e308630b from "./generated-96b5e24c-5220-44f8-869b-ab93e1fab848.json";

import a4f80dc83f815abe10823e6cf38de17e1b from "./generated-d8cd4187-52af-4160-9ded-835d8256ca5e.json";

import a50f65ec161841dc49594972d5de91c33b from "./generated-5c939eb2-8130-4656-8a37-59aeae257d38.json";

import a37f166def39045a630318c47a8bbc6e9b from "./generated-9b127e5a-d25e-4dcf-b38a-cf43b227df3b.json";

import a129edf2ff6883b709d80c2c8a764302bb from "./generated-ccf4bd21-a381-483f-985b-cd6bbc391281.json";

import a5fcf6640d2291b09e05022bf9d4108c8b from "./generated-ea793328-c513-475e-8e80-d3eb91a959b6.json";

import a97435c5a1ecf1cb219e717c88f427562b from "./generated-cd911979-5c8c-4d92-bc7b-62c4832b75bd.json";

import a3556f7b7baa642c26e669d2a3d13516fb from "./generated-842096e8-4dd2-40f3-8f28-77b8c7f536b0.json";

import a7e1fc73394020dd896ab6ede8be44d8bb from "./generated-1a677bb0-fb8c-4597-a126-268ccc2ec932.json";

import a4a5d88ab58567db8e6a1c3600d413a71b from "./generated-d1937242-64a8-4366-9b5c-2b21f5d2e893.json";

import ac709aae0360855dac9794271f246ca94b from "./generated-37bc6729-2e0d-4125-bd36-c1b788c8501e.json";

import a4745285b19b0ab68d1585c44a21e4b9fb from "./generated-a6a5a4ff-18b8-42fa-befa-c1d9c5353794.json";

import a5c5ad1e988a72cd8e653db235d13579ab from "./generated-8bf57871-adb5-4cd7-8719-7b38e7482a8c.json";

import a579ba42f3672c2f12bd44a0194bd69c2b from "./generated-0d59789a-6d46-41f6-afb3-c366f97b4c39.json";

import ae270ab9d3f39d26a21ce0449b657e8a6b from "./generated-f5d6d262-43de-4705-87f6-363d9d3f9fc8.json";

import aa2d94b7bb4ec74f624c9691ce909e9f8b from "./generated-10e36e30-9d8c-4646-845c-406784faab39.json";

import a5d9597ecd5a7ff576f0c75cad6034db5b from "./generated-f00ddc94-9123-4672-8140-b71b914dc18f.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a1f278df92169d342ff3d34089e308630b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a4f80dc83f815abe10823e6cf38de17e1b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a50f65ec161841dc49594972d5de91c33b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a37f166def39045a630318c47a8bbc6e9b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a129edf2ff6883b709d80c2c8a764302bb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a5fcf6640d2291b09e05022bf9d4108c8b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a97435c5a1ecf1cb219e717c88f427562b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a3556f7b7baa642c26e669d2a3d13516fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a7e1fc73394020dd896ab6ede8be44d8bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a4a5d88ab58567db8e6a1c3600d413a71b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ac709aae0360855dac9794271f246ca94b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a4745285b19b0ab68d1585c44a21e4b9fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a7e1fc73394020dd896ab6ede8be44d8bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a5c5ad1e988a72cd8e653db235d13579ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a579ba42f3672c2f12bd44a0194bd69c2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a7e1fc73394020dd896ab6ede8be44d8bb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ae270ab9d3f39d26a21ce0449b657e8a6b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aa2d94b7bb4ec74f624c9691ce909e9f8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a5d9597ecd5a7ff576f0c75cad6034db5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ae270ab9d3f39d26a21ce0449b657e8a6b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */